import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Experience',
    href: '#experience'
  }, {
    name: 'Design Your Home',
    href: '#intelligence'
  }, {
    name: 'Spaces',
    href: '#spaces'
  }, {
    name: 'Systems',
    href: '#control'
  }, {
    name: 'Talk to an Expert',
    href: '#consult'
  }];
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.8,
    ease: [0.16, 1, 0.3, 1]
  }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-glass py-4' : 'bg-transparent py-6'}`} data-id="element-435">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-436">
        <a href="#" className="text-title font-serif text-gradient-gold tracking-widest uppercase" data-id="element-437">
          QUBIX
        </a>

        {/* Desktop Nav */}
        <div className="hidden lg:flex items-center space-x-8" data-id="element-438">
          {navLinks.slice(0, 4).map(link => <a key={link.name} href={link.href} className="text-platinum hover:text-white transition-colors text-sm tracking-wide uppercase" data-id="element-439">
              {link.name}
            </a>)}
          <a href="#consult" className="relative px-6 py-2 text-sm tracking-wide uppercase group overflow-hidden rounded-full" data-id="element-440">
            <span className="absolute inset-0 w-full h-full bg-gradient-to-r from-cinema via-music to-social opacity-80 group-hover:opacity-100 transition-opacity duration-300" data-id="element-441"></span>
            <span className="relative text-white font-medium" data-id="element-442">
              Book Consultation
            </span>
          </a>
        </div>

        {/* Mobile Toggle */}
        <button className="lg:hidden text-platinum hover:text-white transition-colors" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-443">
          {mobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-444" /> : <MenuIcon className="w-6 h-6" data-id="element-445" />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-446">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="lg:hidden bg-obsidian border-b border-graphite overflow-hidden" data-id="element-447">
            <div className="px-6 py-8 flex flex-col space-y-6" data-id="element-448">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setMobileMenuOpen(false)} className="text-platinum text-lg font-serif tracking-wide uppercase" data-id="element-449">
                  {link.name}
                </a>)}
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.nav>;
}